<template>
    <div>
        <b-btn
            v-for="(type, code) in items"
            :key="code"
            :variant="current === code ? 'primary': 'light'"
            activeClass="btn-primary"
            :disabled="disabled"
            @click="onClick(code)"
        >
            {{ type }}
        </b-btn>
    </div>
</template>

<script>
export default {
    name: 'CustomTypeButtonList',
    props: {
        value: {
            type: [String, Number],
            'default': null,
        },

        items: {
            type: Object,
            'default': () => ({}),
        },

        disabled: {
            type: Boolean,
            'default': false,
        },
    },

    inject: ['clearSpecified'],

    data() {
        return {
            current: this.value,
        };
    },

    methods: {
        onClick: function(code) {
            this.clearSpecified();
            this.current = code;
        },
    },

    watch: {
        current: function() {
            this.$emit('input', this.current);
        },

        value: function() {
            this.current = this.value;
        },
    },
};
</script>